// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__EcQoo","selected":"Chip_selected__Re9x8"};